<template>
    <div class="background">
        <LoginDialog></LoginDialog>
    </div>
</template>

<script>
 import LoginDialog from './LoginDialog.vue'

 export default {
     name: 'Login',
     props: {
     },
     components: {
         LoginDialog
     },
 }
</script>

<style scoped>
 .background {
     flex-direction: column;
     align-items: center;
     justify-content: center;
     display: flex;
     width: 100%;
     height: 100%;
     background-image: url("https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/background.jpg");
     background-repeat: no-repeat;
     background-size: 100% 100%;
 }
</style>
